import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Delete extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <path d="M14.5,2.3l-0.8-0.8h-3.6v-1L9.6,0H5.9L5.4,0.5v1H1.8L1,2.3v0.8h1v12.2L2.8,16h10l0.8-0.8V3.1h1V2.3z M6.4,1h2.8v0.5H6.4V1z M12,14.5H3.5V3.1H12V14.5z" />
          <rect x="4.8" y="4.3" width="1" height="9" />
          <rect x="7.2" y="4.3" width="1" height="9" />
          <rect x="9.7" y="4.3" width="1" height="9" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Delete.js